import React, { useEffect } from 'react';
import { Navigate, useNavigate } from 'react-router-dom';
import { clearCredentials } from './store/slices/authSlice';
import { useSelector, useDispatch } from 'react-redux';

const AuthRoute = ({ children }) => {

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const auth = useSelector((state) => state.auth);

  // Listen for session expiration errors
  useEffect(() => {
    if (auth.error && auth.error.includes('session has expired')) {
      dispatch(clearCredentials());
      navigate('/login', { replace: true });
    }
  }, [auth.error, dispatch, navigate]);

  // Check if user is logged in
  if(auth.user === null) {
    return <Navigate to="/login" replace />;
  }

  return children;
};

export default AuthRoute;
